<template>
  <div class="mc-trackvideo-card--timeout-click-area" @click="$emit('clickContinue')">
    <div class="mc-trackvideo-card--timeout">
      <i class="mc-fa icon-outline_video-off"></i>
      <p>{{ $t('trackVideo.timeout') }}</p>
      <b-button variant="primary" size="sm">{{ $t('global.action.continue') }}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateTimeout',
}
</script>
